import React, { Component } from "react";
import Form from "../form";
import moment from "moment";
import { compose } from "redux";
import { withUrlResource, withUrlResourceTimezone } from "common/utils";
import resourceFactory from "common/admin/resourceFactory";
import { AppValues } from "common/constants";
import { getItem, localStorage } from "common/storage";
import client from "common/admin/client";
import { map } from "lodash";
class CreateNotification extends Component {
  state = {
    floors: [],
    companies: [],
    buildings: [],
  };

  async componentDidMount() {
    const { urlResource } = this.props;
    try {
      const floorsPromise = resourceFactory("floors").getAll({
        building_id: urlResource.id,
      });
      const companiesPromise = resourceFactory("companies").getAll({
        building_id: urlResource.id,
      });
      const buildingsPromise = resourceFactory(
        `buildings/${urlResource.id}/admin`,
      ).getAll();

      const [floors, companies, buildings] = await Promise.all([
        floorsPromise,
        companiesPromise,
        buildingsPromise,
      ]);

      this.setState({ floors, companies, buildings });
    } catch (error) {
      console.error("Error fetching resources:", error);
    }
  }

  handleSubmit = async (values, form, cb = () => {}) => {
    const { target, isContest } = values;

    let url =
      target === "building"
        ? `buildings/${this.props.urlResource.id}/notifications/bulk`
        : `buildings/${this.props.urlResource.id}/notifications`;
    const { setSubmitting, setErrors, setStatus, resetForm } = form;
    const multilingual = getItem(localStorage, AppValues.multilingual) || false;

    const formData = new window.FormData();
    // Append the picked values to FormData
    Object.keys(values).forEach((key) => {
      if (key === "image") {
        if (values[key] && values[key] instanceof File) {
          formData.append("image", values[key]); // Ensure image is properly appended
        }
      } else if (key === "floors") {
        formData.append(
          key,
          target === "floor"
            ? [values[key]]
            : target === "building"
              ? map(this.floors, ({ id }) => String(id))
              : [],
        );
      } else if (key === "companies") {
        formData.append(key, target === "company" ? [values[key]] : []);
      } else if (key === "buildings") {
        formData.append(
          key,
          target === "building" ? values[key].join(",") : "",
        );
      } else if (key === "available_at" || key === "available_until") {
        // Format date values to ISO 8601 format
        formData.append(key, new Date(values[key]).toISOString());
      } else if (key === "isContest") {
        // Format date values to boolean
        formData.append("is_contest", isContest);
      } else if (key === "max_registrations") {
        formData.append("max_registrations", values[key] ?? null);
      } else {
        formData.append(key, values[key]); // Append the other fields
      }
    });

    formData.append("multilingual", multilingual);

    try {
      await client.post(url, { body: formData });
      resetForm();
      cb();
      setStatus({ success: true });
    } catch (e) {
      setErrors({ http: e.message });
    }
    setSubmitting(false);
  };

  render() {
    const { urlResource } = this.props;
    const { floors, companies, buildings } = this.state;
    const ishilo = localStorage.getItem("HILO") === "true";
    const lang = localStorage.getItem("i18nLang");
    this.companies = companies || [];
    this.floors = floors || [];

    return (
      <Form
        isCreate
        handleSubmit={this.handleSubmit}
        floors={floors}
        companies={companies}
        buildings={buildings}
        timezone={urlResource.timezone}
        lang={lang}
        initialValues={{
          title: "",
          rsvp_form_url: "",
          rsvp_button_text: "",
          description: "",
          html_content: "",
          image: "",
          send_push_notification: false,
          target: "",
          floors: [],
          companies: [],
          buildings: buildings.map((b) => b.building_id),
          available_at: moment().add(5, "m").toDate(),
          available_until: moment().add(10, "m").toDate(),
          n_type: "NOTIFICATION",
          max_registrations: null,
          ishilo,
          isContest: false,
        }}
      />
    );
  }
}

const enhanced = compose(withUrlResource, withUrlResourceTimezone);

export default enhanced(CreateNotification);
